import { CampaignType } from '../../../../constants/marketingCampaign'
import { BuildFormValuesContext } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { FixedAmountRuleState } from './types'

export function buildFixedAmountFormValues(
	ctx: BuildFormValuesContext<FixedAmountRuleState>,
): Record<string, unknown> {
	const { rule, confirmation, selectedShopIds, campaignMeta, marketingCampaignKey } = ctx
	const base: Record<string, unknown> = {
		startDate: confirmation.startDate,
		startTime: confirmation.startTime,
		discount: rule.discount,
		threshold: rule.threshold,
		type: CampaignType.FIXED_AMOUNT_DISCOUNT_AFTER_THRESHOLD,
		shopIds: selectedShopIds,
		valueType: campaignMeta.valueType,
		marketingCampaignKey,
		orderTypes: confirmation.orderTypes,
		isPermanent: confirmation.isPermanent,
	}

	if (!confirmation.isPermanent) {
		base.endDate = confirmation.endDate
		base.endTime = confirmation.endTime
	}

	return base
}
